<template>
  <div id="page-user-list">
    <!--     <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Status</label>
          <v-select
            :options="optionStatus"
            :clearable="false"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="statusModel"
            class="mb-4 md:mb-0"
          />
        </div>

        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <vs-button @click="Export" class="mt-6 md:mb-0" v-show="false"
            >Export</vs-button
          >
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full"></div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full"></div>
      </div>
    </vx-card> -->
    <vx-card ref="filterCard" class="user-list-filters mb-8">
      <div class="vx-row">
        <div class="vx-col md:w-1/1 sm:w-1/1 w-full">
          <vs-table
            pagination
            search
            max-items="20"
            :data="data"
            :stripe="true"
            v-if="data != null"
            v-model="selected"
            @selected="editData(selected)"
          >
            <template slot="thead">
              <vs-th sort-key="userName">Username</vs-th>
              <vs-th sort-key="companyName">CompanyName</vs-th>
              <vs-th sort-key="status">Status</vs-th>
              <vs-th sort-key="approvalStatus">Approval Status</vs-th>
              <vs-th sort-key="isLock">Lock</vs-th>
              <vs-th sort-key="lastestLogin">Lastest Login</vs-th>
              <vs-th sort-key="action">Action</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <!-- <vs-td :data="indextr">
                  {{ indextr }}
                </vs-td> -->
                <vs-td :data="data[indextr].userName">
                  {{ data[indextr].userName }}
                </vs-td>
                <vs-td :data="data[indextr].companyName">
                  {{ data[indextr].companyName }}
                </vs-td>
                <vs-td :data="data[indextr].status">
                  <vs-chip
                    :color="setStatusColor(data[indextr].status)"
                    transparent
                    >{{
                      data[indextr].status == "Register"
                        ? "Registered"
                        : data[indextr].status
                    }}</vs-chip
                  >
                </vs-td>
                <vs-td :data="data[indextr].approvalStatus">
                  <vs-chip
                    color="#6AB96F"
                    transparent
                    v-if="data[indextr].approvalStatus == 'Approve'"
                    >{{ data[indextr].approvalStatus }}d</vs-chip
                  >
                  <vs-chip
                    color="warning"
                    transparent
                    v-if="data[indextr].approvalStatus == 'Revise'"
                    >{{ data[indextr].approvalStatus }}d</vs-chip
                  >
                  <vs-chip
                    color="danger"
                    transparent
                    v-if="data[indextr].approvalStatus == 'Reject'"
                    >{{ data[indextr].approvalStatus }}ed</vs-chip
                  >
                  <vs-chip
                    color="warning"
                    transparent
                    v-if="data[indextr].approvalStatus == 'WaitingApproval'"
                    >{{ data[indextr].approvalStatus }}</vs-chip
                  >
                </vs-td>
                <vs-td :data="data[indextr].isLock">
                  <vs-chip
                    color="danger"
                    transparent
                    v-if="data[indextr].isLock"
                    >Yes</vs-chip
                  >
                  <vs-chip
                    color="primary"
                    transparent
                    v-if="!data[indextr].isLock"
                    >No</vs-chip
                  >
                </vs-td>
                <vs-td :data="data[indextr].lastestLogin">
                  {{ format(data[indextr].lastestLogin) }}
                </vs-td>
                <vs-td>
                  <feather-icon
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    @click.stop="editVendor(tr)"
                  />
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <pre v-if="data == null">No data Available.</pre>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";

// Services
import { _vendorservice } from "../../services/vendorservices";
import { dateFormat } from "../../services/utility";

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      optionStatus: [
        { label: "Register", value: "Register" },
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
        { label: "Warning", value: "Warning" },
        { label: "Blacklist", value: "Blacklist" },
      ],

      statusModel: { label: "Register", value: "Register" },

      data: [],
      selected: {},
    };
  },
  created() {
    this.getVendorList();
  },
  methods: {
    async getVendorList() {
      this.$vs.loading({
        type: "sound",
      });
      /* this.data = await _vendorservice.GetVendorListByStatus(
        this.statusModel.value
      ); */
      this.data = await _vendorservice.GetVendorListByApprovalStatus(
        "WaitingApproval"
      );
      this.$vs.loading.close();

      // Sign out when token expire
      /* if (this.data == undefined) {
        this.$msal.signOut();
      } */
      // console.log(this.data);
    },
    async editData(model) {
      this.$router
        .push(`/procurement-management/vendor/main/${model.id}`)
        .catch(() => {});
      // console.log(model);
    },

    Export() {},

    setStatusColor(status) {
      let color = "";
      if (status == "Register") {
        color = "primary";
      }

      if (status == "Active") {
        color = "#6AB96F";
      }

      if (
        status == "Inactive" ||
        status == "Warning" ||
        status == "Blacklist"
      ) {
        color = "danger";
      }

      return color;
    },

    format(date) {
      if (date != null) return dateFormat(date);

      return null;
    },
  },
  watch: {
    statusModel() {
      this.getVendorList();
    },
  },
};
</script>

<style lang="scss" scoped></style>
